import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconRemoveTextstyle: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="remove-textstyle"><path d="M2.75 3.75L20.25 19.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M9.79688 20.25L10.9152 11.4629" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M11.3906 7.75209L11.8682 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M8.75 3.75H19.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconRemoveTextstyle;
